import { Button, IconButton, TableContainer, Table, TableHead, TableRow, TableBody, Paper, TableCell, Typography, Grid } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import { DialogMessage } from "../../../global/DialogMessage"
import { ToastMessage } from "../../../global/ToastMessage"
import FCotizacion from "./FCotizacion"
import { useDispatch, useSelector } from "react-redux"
import { formatDinero } from "../../../utils/formatDinero"
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import { obtenerBancoMainAction, obtenerPlazosBanoAction, obtenerPlanPagosHibrido, addAdultosAction, addMenoresAction, addInfantesAction, addClavePaqueteAction, addItemsAction, modalDetalleExtraAction, newCotizacionPaqueteAction, addMetodoPagoAction, addFechaSalidaAction, obtenerMensualidadesAction, updateCotizacionPaqueteAction, addPaqueteAction, addBancoAction, addBancoMensualidadAction } from "../../../ducks/cotizadorPaqueteDuck"
import { obtenerClientesCotizadorAction, obtenerClientesCotizadorAllAction, modalViewCotizadorAction, obtenerNoInteresadosAction } from "../../../ducks/cotizadorDuck"
import { StringItemsType } from "../../../constant/StringItemsType"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
import { useEffect } from "react"
import VisibilityIcon from "@material-ui/icons/Visibility"
import VPagos from "./VPagos"
import MDetalleExtra from "./MDetalleExtra"
import { FormatoFechaIso } from "../../../utils/FormatFecha"
import { catTipoPago } from "../../../constant/catTipoPago"
import { catCotizador } from "../../../constant/constantes"
import { catTipoItem } from "../../../constant/catTipoItem"
export const VCambioPasajerosStyle = makeStyles((theme) => ({
    root: {
        margin: "10px 0",
    },
    content: {
        margin: "20px 0",
    },
    contentButton: {
        margin: "20px 0",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    table: {
        minWidth: 650,
    },
}))

const validarPaquete = ({ listaItems, metodoPago, banco, bancoMensualidad }) => {
    const tieneSalidaYPlaza = [StringItemsType.SALIDA, StringItemsType.PLAZA].every(tipo =>
        listaItems.some(item => item.type === StringItemsType[tipo])
    );
    const tieneCantidadValida = listaItems.some(item => item.quantity >= 1);
    const esPagoHibridoOCredito = [catTipoPago.HIBRIDO, catTipoPago.TARJETA_CREDITO].includes(Number(metodoPago));
    if (!tieneSalidaYPlaza || !tieneCantidadValida) return false;
    if (metodoPago === String(catTipoPago.NOAPLICA)) return false;
    if (esPagoHibridoOCredito && (banco === "0" || bancoMensualidad === "undefined" || bancoMensualidad === "0")) return false;
    return true;
};

//! Metodo en desuso
// const validarPaquete = ({ listaItems, metodoPago, banco, bancoMensualidad }) => {
//     if (!listaItems.some(item => item.type === StringItemsType.SALIDA))
//         return false
//     if (!listaItems.some(item => item.type === StringItemsType.PLAZA))
//         return false
//     if (!listaItems.some(item => item.quantity >= 1))
//         return false
//     if (metodoPago === String(catTipoPago.NOAPLICA))
//         return false
//     if (metodoPago === String(catTipoPago.HIBRIDO) || metodoPago === String(catTipoPago.TARJETA_CREDITO)) {
//         if (banco === "0")
//             return false
//         if (bancoMensualidad === 'undefined' || bancoMensualidad === "0")
//             return false
//     }
//     return true
// }
const useObtenerTasaGeneral = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerBancoMainAction()).then(Response => {
            dispatch(offLoadAction())
        })
    }, [dispatch])
}
const CambioPaquete = () => {
    const classes = VCambioPasajerosStyle()
    const dispatch = useDispatch()
    const { cliente, update, idCotizacion, cotizacion } = useSelector(store => store.cotizador)
    const {  paquete, listaFechaSalida, metodoPago, listaItems, banco, cantidadMenores, cantidadInfantes, cantidadAdultos, listaPlazosBanco, bancoMensualidad } = useSelector(store => store.cotizadorPaquete)
    const handleDeleteItem = (idItem) => {
        let arraItems = listaItems.filter(item => item.id !== idItem)
        dispatch(addItemsAction({ listaItem: arraItems }))
    }
    useObtenerTasaGeneral()
    useEffect(() => {
        const loadData = () => {
            let arrayItems = []
            let cantidadMenores = 0
            let cantidadInfantes = 0
            let cantidadAdultos = cotizacion?.Adultos || 0
            let objetoFechaSalida = {}
            const precioAumentado =  cotizacion?.EnvioPaqueteProveedor?.PrecioAumento || 0
            const precioPaquete = cotizacion?.EnvioPaqueteProveedor?.Precio || 0
            const montoPromocionTotal = cotizacion?.MontoPromocion || 0
            const formatoPago = cotizacion?.lFormatoPago
            const isPlanPagos = formatoPago.length === 1 && Number(formatoPago[0].CatTipoPago.IdCatTipoPago) === catTipoPago.PLAN_PAGOS
            let precioPaqueteFinal = (precioAumentado > 0) ? precioAumentado : precioPaquete
            let objetoPaquete = {
                Nombre: cotizacion?.NombrePaquete,
                Descripcion: cotizacion?.Descripcion,
                PrecioPublico: precioPaqueteFinal,
                Moneda: { id_moneda: cotizacion?.Moneda?.id_moneda, Clave: cotizacion?.Moneda?.Clave },
                ClavePaquete: cotizacion?.ClavePaquete,
                MonedaPagoProveedor: { id_moneda: cotizacion?.MonedaProveedor?.id_moneda, Clave: cotizacion?.MonedaProveedor?.Clave },
                TipoCambioPrevisto: cotizacion?.TipoCambioPrevisto,
                envioPaqueteProveedor: { IdObjeto: cotizacion?.EnvioPaqueteProveedor?.IdObjeto },
                Internacional: cotizacion?.Internacional,
                PrecioDescuento: (precioAumentado <= 0) ? 0 : precioPaquete,
            }
            let itemPaquete = {
                id: `${cotizacion?.EnvioPaqueteProveedor?.IdObjeto}`,
                name: cotizacion.NombrePaquete,
                price: precioPaqueteFinal,
                currency: cotizacion.Moneda?.Clave,
                type: catTipoItem.PAQUETE,
                quantity: cantidadAdultos
            }
            arrayItems.push(itemPaquete)
            let arraySuplementos = cotizacion?.lContizacionSuplemento.map((suplemento, index) => {
                let itemSuplemento = {
                    id: suplemento.IdObjeto,
                    name: suplemento.Descripcion,
                    price: suplemento.Precio,
                    currency: cotizacion.Moneda?.Clave,
                    type: suplemento.TipoSuplemento,
                    quantity: suplemento.Cantidad
                }
                if (suplemento.TipoSuplemento.includes(catTipoItem.SALIDA)) {
                    objetoFechaSalida = suplemento
                    itemSuplemento.name = `${FormatoFechaIso({ date: cotizacion.FechaSalida, formato: "yyyy/MM/dd" })}`
                }
                if (suplemento.Descripcion.includes("Menor")) {
                    cantidadMenores = suplemento.Cantidad
                    itemSuplemento.price = precioPaqueteFinal + suplemento.Precio
                    itemSuplemento.type = "PLAZAM"
                }
                if (suplemento.Descripcion === "Infante") {
                    itemSuplemento.type = "PLAZAI"
                    cantidadInfantes = suplemento.Cantidad
                }
                return itemSuplemento
            })
            let arrayDescuentos = cotizacion?.lCotizacionOferta.map((descuento, index) => {
                let descuentoTipo = catTipoItem.DESCUENTO_MONTO
                if (descuento.Operacion === "*") {
                    descuentoTipo = catTipoItem.DESCUENTO_PORCENTAJE
                }
                let itemDescuento = {
                    id: descuento.IdCotizacionOferta,
                    name: `${descuento.Descripcion}`,
                    price: descuento.Cantidad,
                    currency: paquete.Moneda?.Clave,
                    type: descuentoTipo,
                    quantity: cantidadAdultos + cantidadMenores + cantidadInfantes,
                    description: `${descuento.Descripcion}`
                }
                return itemDescuento
            })
            let itemDescuento = {
                id: 0,
                name: `Promoción BBVA`,
                price: precioPaquete - precioAumentado,
                currency: paquete.Moneda?.Clave,
                type: catTipoItem.PROMOCION,
                quantity: cantidadAdultos + cantidadMenores + cantidadInfantes,
                description: `Promoción BBVA`
            }
            let arraySuplementosC = arraySuplementos
            if (isPlanPagos) {
                arrayItems.push(itemDescuento)
                arraySuplementosC = arraySuplementos.concat(arrayDescuentos)
            }
            dispatch(addPaqueteAction({ paquete: objetoPaquete }))
            dispatch(addAdultosAction({ cantidad: cantidadAdultos }))
            dispatch(addMenoresAction({ cantidad: cantidadMenores }))
            dispatch(addInfantesAction({ cantidad: cantidadInfantes }))
            dispatch(addClavePaqueteAction({ clavePaquete: cotizacion.ClavePaquete }))
            let arrayItemsC = arrayItems.concat(arraySuplementosC)         
            arrayItemsC.sort((a, b) => (a.type === 'PROMOCION' ? 1 : b.type === 'PROMOCION' ? -1 : 0));
            dispatch(addItemsAction({ listaItem: arrayItemsC }))
            
            const total = arrayItemsC.reduce((a, b) => {
                return a + (![catTipoItem.DESCUENTO_MONTO, catTipoItem.DESCUENTO_PORCENTAJE].includes(b.type) ? b.price * b.quantity : 0);
            }, 0)

            const fechaFind = listaFechaSalida.find(fecha => fecha.IdObjeto === objetoFechaSalida?.IdObjeto)
            let fecha = `0,0,0,0`
            if (fechaFind) {
                fecha = `${fechaFind.IdObjeto},${fechaFind.IdBloqueSalida},${fechaFind.FechaSalida},${fechaFind.Precio}`
            }
            dispatch(addFechaSalidaAction({ fechaSalida: fecha, fecha: cotizacion.FechaSalida }))

            //* calcular metodos de pago 
            let montoTotal = total
            let montoFinal = total
            let idBanco = 0
            let pagosBanco = 0
            let metodoPago = 0
            let mensualidadBanco = { IdBancoMensualidad: 0 }
            // * Obtener el tipo de pago
            cotizacion?.lFormatoPago.forEach(tipoPago => {
                metodoPago = tipoPago?.CatTipoPago?.IdCatTipoPago
                if (tipoPago?.BancoFormatoPago && tipoPago?.CatTipoPago?.IdCatTipoPago === 2) {
                    idBanco = tipoPago?.BancoFormatoPago?.Banco?.IdBanco
                    pagosBanco = tipoPago?.NumeroPagos

                }
            })
            if (cotizacion?.lFormatoPago.length >= 2) {
                metodoPago = catTipoPago.HIBRIDO
            }
            dispatch(addMetodoPagoAction({ metodoPago: String(metodoPago) }))
            dispatch(addBancoAction({ banco: idBanco ?? 0 }))
            if (pagosBanco > 0) {
                mensualidadBanco = listaPlazosBanco.find(valor => Number(valor?.Mensualidad?.Cantidad) === Number(pagosBanco))
            }
            if (!mensualidadBanco) {
                mensualidadBanco = { IdBancoMensualidad: "0" }
            }
            if (metodoPago === catTipoPago.HIBRIDO) {
                montoTotal = montoTotal * catCotizador.PORCENTAJE_MENSUALIDAD_HIBRIDO
                montoFinal = montoFinal * catCotizador.PORCENTAJE_TARJETA_CREDITO_HIBRIDO
                dispatch(obtenerPlanPagosHibrido({
                    FecSalida: cotizacion.FechaSalida,
                    IdBanco: idBanco,
                    NumPagoCIE: catCotizador.CANTIDAD_PAGOS_ADIFERIR,
                    PorCIE: catCotizador.PORCENTAJE_MENSUALIDAD_HIBRIDO * 100,
                    PorTC: catCotizador.PORCENTAJE_TARJETA_CREDITO_HIBRIDO * 100,
                    PrecioPaquete: montoTotal
                }))
            }

            dispatch(obtenerPlazosBanoAction({ IdBanco: idBanco, PrecioPaquete: montoFinal }))
            dispatch(addBancoMensualidadAction({ bancoMensualidad: String(mensualidadBanco?.IdBancoMensualidad) }))
            // dispatch(obtenerMensualidadesAction({ fecha: FormatoFechaIso({ date: cotizacion.FechaSalida, formato: "MMddyyyy" }), monto: montoTotal }))
        }
        if (idCotizacion > 0 && cotizacion?.IdCotizacion)
            loadData()
    }, [dispatch, idCotizacion, cotizacion])

    useEffect(() => {
        let arrayItems = [...listaItems]
        const paxAdultos = Number(cantidadAdultos)
        const paxMenores = Number(cantidadMenores)
        const paxInfantes = Number(cantidadInfantes)
        const paxTotales = paxMenores + paxAdultos + paxInfantes
        arrayItems = arrayItems.map(item => {
            if (item.type === catTipoItem.PAQUETE) {
                let precio = paquete.PrecioPublico
                let totalPax = paxAdultos
                // if (Number(metodoPago) === catTipoPago.PLAN_PAGOS && paquete.PrecioDescuento > 0)
                //     precio = paquete.PrecioDescuento
                if (Number(paxAdultos) === 1 && Number(paxMenores) > 1) {
                    totalPax = totalPax + 1
                }
                return { ...item, quantity: totalPax, price: precio }
            }
            if (item.type === catTipoItem.SALIDA || item.type === catTipoItem.EXTRA)
                return { ...item, quantity: paxTotales }
            return item
        })
        if (Number(metodoPago) !== catTipoPago.PLAN_PAGOS) {
            arrayItems = arrayItems.filter(item => item.type !== catTipoItem.DESCUENTO_MONTO && item.type !== catTipoItem.DESCUENTO_PORCENTAJE)
        }
        arrayItems = arrayItems.filter(item => item.type !== catTipoItem.PROMOCION)
        if (Number(metodoPago) === catTipoPago.PLAN_PAGOS) {
            let itemDescuento = {
                id: 0,
                name: `Promoción BBVA`,
                price: paquete?.PrecioDescuento - paquete?.PrecioPublico,
                currency: paquete.Moneda?.Clave,
                type: catTipoItem.PROMOCION,
                quantity: paxTotales,
                description: `Promoción BBVA`
            }
            arrayItems.push(itemDescuento)
        }
        dispatch(addItemsAction({ listaItem: arrayItems }))
    }, [dispatch, cantidadInfantes, cantidadMenores, cantidadAdultos, metodoPago])

    const handleOpenDetalleExtra = ({ id }) => {
        dispatch(modalDetalleExtraAction({ open: true, idExtra: id }))
    }

    const handleClickGuardar = () => {
        DialogMessage.fire({
            title: '¿Estas seguro de gaurdar esta cotización?',
            text: '',
            showCancelButton: true,
            confirmButtonText: "Aplicar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({ message: "" }))
                dispatch(newCotizacionPaqueteAction()).then(Response => {
                    dispatch(offLoadAction())
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema intentar mas tarde",
                        });
                        return null;
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: Response.Message,
                        });
                        return null;
                    }
                    dispatch(modalViewCotizadorAction({ open: false }))
                    dispatch(obtenerClientesCotizadorAction())
                    dispatch(obtenerClientesCotizadorAllAction())
                    dispatch(addItemsAction({ listaItem: [] }))
                    dispatch(addMetodoPagoAction({ metodoPago: "0" }))
                    dispatch(obtenerNoInteresadosAction())
                    const autoComplete = document.getElementsByClassName('MuiAutocomplete-clearIndicator')[2];
                    if (autoComplete) {
                        autoComplete.click()
                    }
                    const autoComplete2 = document.getElementsByClassName('MuiAutocomplete-clearIndicator')[1];
                    if (autoComplete2) {
                        autoComplete2.click()
                    }
                    ToastMessage.fire(
                        '¡Se aplico el cambio de paquete!',
                        '',
                        'success'
                    )
                })
            }
        })
    }
    const handleClickActulizar = () => {
        DialogMessage.fire({
            title: '¿Estas seguro de gaurdar esta cotización?',
            text: '',
            showCancelButton: true,
            confirmButtonText: "Aplicar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({ message: "" }))
                dispatch(updateCotizacionPaqueteAction()).then(Response => {
                    dispatch(offLoadAction())
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema intentar mas tarde",
                        });
                        return null;
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: Response?.Message,
                        });
                        return null;
                    }
                    dispatch(modalViewCotizadorAction({ open: false }))
                    dispatch(obtenerClientesCotizadorAction())
                    dispatch(obtenerClientesCotizadorAllAction())
                    dispatch(addItemsAction({ listaItem: [] }))
                    dispatch(addMetodoPagoAction({ metodoPago: "0" }))
                    dispatch(obtenerNoInteresadosAction())
                    const autoComplete = document.getElementsByClassName('MuiAutocomplete-clearIndicator')[2];
                    if (autoComplete) {
                        autoComplete.click()
                    }
                    const autoComplete2 = document.getElementsByClassName('MuiAutocomplete-clearIndicator')[1];
                    if (autoComplete2) {
                        autoComplete2.click()
                    }
                    ToastMessage.fire(
                        '¡Se aplico el cambio de paquete!',
                        '',
                        'success'
                    )
                })
            }
        })
    }
    return (
        <div className={classes.root}>
            <Grid container>
                {/* <Grid item xs={12}>
                    Clinete target: {cliente.Nombre}
                    <br />
                    Total pasajeros: {cantidadPasajeros}
                    <br />
                    update: {`${update}`}
                    <br />
                    idCotizacion: {idCotizacion}
                </Grid> */}
                <Grid item xs={3}>
                    <FCotizacion />
                </Grid>
                <Grid item xs={9}>
                    <div style={{ position: "sticky" }}>
                        <TableContainer component={Paper}>
                            <Table className={classes.table} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">Item</TableCell>
                                        <TableCell align="center">Monto unitario</TableCell>
                                        <TableCell align="center">Cantidad</TableCell>
                                        <TableCell align="center">Monto</TableCell>
                                        <TableCell align="center">Moneda</TableCell>
                                        <TableCell align="center">Acción</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        listaItems.map((item, index) => {
                                            if (item.type === catTipoItem.DESCUENTO_MONTO || item.type === catTipoItem.DESCUENTO_PORCENTAJE) {
                                                let descuentoPrecio = `${formatDinero(item.price)}`
                                                let moneda = item.currency
                                                if (item.type === catTipoItem.DESCUENTO_PORCENTAJE) {
                                                    descuentoPrecio = `${item.price}%`
                                                    moneda = ""
                                                }
                                                return (
                                                    <TableRow key={item.id}>
                                                        <TableCell align="center">{`${item.type} - ${item.name}`}</TableCell>
                                                        <TableCell align="center"></TableCell>
                                                        <TableCell align="center"></TableCell>
                                                        <TableCell align="center">{descuentoPrecio}</TableCell>
                                                        <TableCell align="center">{moneda}</TableCell>
                                                        <TableCell align="center">
                                                            <IconButton onClick={() => { handleDeleteItem(item.id) }}>
                                                                <HighlightOffIcon />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            }

                                            return (
                                                <TableRow key={item.id}>
                                                    <TableCell align="center">{`${item.type} - ${item.name}`}</TableCell>
                                                    <TableCell align="center">{formatDinero(item.price)}</TableCell>
                                                    <TableCell align="center">{item.quantity}</TableCell>
                                                    <TableCell align="center">{formatDinero(item.price * item.quantity)}</TableCell>
                                                    <TableCell align="center">{item.currency}</TableCell>
                                                    <TableCell align="center">
                                                        {
                                                            (item.type === catTipoItem.EXTRA) &&
                                                            <IconButton onClick={() => { handleDeleteItem(item.id) }}>
                                                                <HighlightOffIcon />
                                                            </IconButton>
                                                        }
                                                        {
                                                            (item.type === catTipoItem.EXTRA) &&
                                                            <IconButton onClick={() => { handleOpenDetalleExtra({ id: item.id }) }}>
                                                                <VisibilityIcon color="primary" />
                                                            </IconButton>
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div className={classes.content}>
                            <VPagos />
                            <MDetalleExtra />
                        </div>
                        <div className={classes.contentButton}>
                            <Button
                                onClick={(update) ? handleClickActulizar : handleClickGuardar}
                                variant="contained"
                                color="primary"
                                disabled={!validarPaquete({ listaItems, metodoPago, banco, bancoMensualidad })}
                            >
                                {
                                    (update) ? "Actulziar" : "Guardar"
                                }
                            </Button>
                        </div>
                    </div>
                </Grid>
            </Grid>
        </div>
    )
}
export default CambioPaquete